import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=f66f3268&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style1 from "./Footer.vue?vue&type=style&index=1&id=f66f3268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f3268",
  null
  
)

export default component.exports